import { render, staticRenderFns } from "./AnswerResult.vue?vue&type=template&id=8e14752a&"
import script from "./AnswerResult.vue?vue&type=script&lang=js&"
export * from "./AnswerResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports